import React, { MouseEvent, MouseEventHandler, useCallback } from 'react';
import { StyledExternalLink } from './styles';
interface IProps {
  children: React.ReactNode;
  className: string;
  'data-testid'?: string;
  key?: string;
  onLinkClick?: (event: MouseEvent) => void;
  plain: boolean;
  title?: string;
}

const CustomLink = ({
  children,
  className,
  onLinkClick,
  plain,
  title,
  key,
  ...props
}: IProps) => {

  const onClick = useCallback<MouseEventHandler>((event) => {
    event.preventDefault();
    if (onLinkClick) {
      onLinkClick(event);
    }
  }, [onLinkClick]);

  return (
    <StyledExternalLink
      className={`${className}${plain ? ' plain' : ''}`}
      data-testid={props['data-testid']}
      href="#"
      onClick={onClick}
      title={title}
      key={key}
    >
      {
        children
      }
    </StyledExternalLink>
  );
};

CustomLink.defaultProps = {
  onLinkClick: undefined,
  title: undefined,
};

export default CustomLink;
